export const actionTypes = {
  REQUEST_START: 'TAPS.TAX_AUTHORITY.PARENT.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.TAX_AUTHORITY.PARENT.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.TAX_AUTHORITY.PARENT.REQUEST_FAILURE',
};

export function startRequest(taxCode) {
  return {
    type: actionTypes.REQUEST_START,
    payload: taxCode,
  };
}

export function requestSuccess(data, taxCode) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { data, taxCode },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
